import { createFileRoute } from "@tanstack/react-router";

import { CountPage } from "../../../../features/inventory/count-page";

export const Route = createFileRoute("/_app/inventory/counts/$id")({ component: CountRoute });

function CountRoute() {
  const { id } = Route.useParams();
  return <CountPage key={id} id={id} />;
}
